import { About } from "@/components/About";
import { WhyChooseUs } from "@/components/WhyChooseUs";
import { Testimonials } from "@/components/Testimonials";
import { useSEO } from "@/lib/useSEO";

export const AboutPage = () => {
  useSEO({
    title: "About Us",
    description: "Learn the story behind Annapurna Home Pickles — homemade Andhra pickles made with traditional, hand-ground spices and pure ingredients.",
  });
  return (
    <>
      <About />
      <WhyChooseUs />
      <Testimonials />
    </>
  );
};
